import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectPropertyEnrichment = createSelector(
  selectLoanApplication,
  ({ propertyEnrichment }) => propertyEnrichment ?? {},
);

export const selectPropertyEnrichmentData = createSelector(
  selectPropertyEnrichment,
  ({ data }) => data ?? null,
);

export const selectIsPropertyEnrichmentLoading = createSelector(
  selectPropertyEnrichment,
  ({ isLoading }) => !!isLoading,
);
